module.exports = {"dashboard":"Bord","documentManagement":"Gestionarea Documentelor"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/ro/translation.json
// module id = 1767
// module chunks = 0